import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, CheckIcon, FileTextIcon, UploadIcon, RefreshCwIcon } from 'lucide-react';
import { StatusBadge } from '../ui/StatusBadge';
import { Button } from '../ui/Button';
import type { DocumentItem } from '../../types/application';
import { useTokens } from '../../hooks/useTokens';
interface DocumentRowProps {
  doc: DocumentItem;
  onUpload: (doc: DocumentItem) => void;
}
export function DocumentRow({
  doc,
  onUpload
}: DocumentRowProps) {
  const actionable = doc.status === 'needed' || doc.status === 'attention';
  const {
    fill
  } = useTokens();
  return <motion.li layout transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:gap-4 md:p-5" data-id="element-395" data-mp="1tum5zbbgl2p4">
      <div className="flex min-w-0 flex-1 gap-4" data-id="element-396" data-mp="11d9vofobrvon">
        <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-xl ${doc.status === 'accepted' ? 'bg-positive-50 text-positive-500' : doc.status === 'attention' ? 'bg-critical-50 text-critical-500' : 'bg-ink-100 text-ink-500'}`} data-id="element-397" data-mp="11bynm3nuk1rq">
          {doc.status === 'accepted' ? <CheckIcon className="h-5 w-5" aria-hidden data-id="element-398" data-mp="1ly7skoo5ghx5" /> : doc.status === 'attention' ? <AlertTriangleIcon className="h-5 w-5" aria-hidden data-id="element-399" data-mp="1qrj4h47tjovx" /> : <FileTextIcon className="h-5 w-5" aria-hidden data-id="element-400" data-mp="1vpuaf3uztf8v" />}
        </span>
        <div className="min-w-0 flex-1" data-id="element-401" data-mp="1vryfvq8jimb9">
          <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1" data-id="element-402" data-mp="y356gogqcskd">
            <h3 className="font-medium text-ink-900" data-id="element-403" data-mp="1316lmyb1c7qk">{doc.name}</h3>
            <StatusBadge status={doc.status} data-id="element-404" data-mp="133j194tbm60g" />
          </div>
          <p className="mt-1 text-sm leading-snug text-ink-500" data-id="element-405" data-mp="17zhup6tiae7q">{fill(doc.reason)}</p>
          {doc.note && <p className="mt-1.5 text-sm font-medium text-critical-700" data-id="element-406" data-mp="1d0noz92te9jd">{doc.note}</p>}
          {!actionable && doc.files.length > 0 && <p className="mt-1.5 truncate text-[13px] text-ink-400" data-id="element-407" data-mp="2jfex9xu9ownf">{doc.files.join(' · ')}</p>}
        </div>
      </div>
      <div className="sm:pl-0 pl-[60px]" data-id="element-408" data-mp="2ogvthg1t3uxo">
        {actionable ? <Button size="sm" variant={doc.status === 'attention' ? 'dark' : 'primary'} icon={doc.status === 'attention' ? <RefreshCwIcon className="h-4 w-4" data-id="element-410" data-mp="jd70e5w97vyz" /> : <UploadIcon className="h-4 w-4" data-id="element-411" data-mp="xcy9bs7wym64" />} onClick={() => onUpload(doc)} data-id="element-409" data-mp="ob8m6yl2e9e5">
            {doc.status === 'attention' ? 'Replace' : 'Upload'}
          </Button> : doc.status !== 'accepted' ? <Button size="sm" variant="ghost" onClick={() => onUpload(doc)} data-id="element-412" data-mp="5lsglwuivqqv">
            Add pages
          </Button> : null}
      </div>
    </motion.li>;
}